import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import Loader from '../common/Loader';
import { useRolePermissionMatrix } from '../../hooks/useRolePermissionMatrix';
import { getReportSectionVisibility } from '../../utils/permissions';

function sessionRoleNormalized() {
  try {
    const u = JSON.parse(sessionStorage.getItem('user') || '{}');
    return String(u?.role || '')
      .trim()
      .toLowerCase();
  } catch {
    return '';
  }
}

export function RequireAssetReportsAccess({ children }) {
  const location = useLocation();
  const { rolePermissions, permissionsReady } = useRolePermissionMatrix();
  const normalizedRole = sessionRoleNormalized();
  const allowed = useMemo(
    () =>
      getReportSectionVisibility(normalizedRole, rolePermissions).showAssetReports,
    [normalizedRole, rolePermissions]
  );

  const fallbackReports = location.pathname.startsWith('/employee')
    ? '/employee/reports'
    : '/admin/reports';

  if (!permissionsReady) return <Loader />;
  if (!allowed) return <Navigate to={fallbackReports} replace />;
  return children;
}

export function RequirePerformanceReportsAccess({ children }) {
  const location = useLocation();
  const { rolePermissions, permissionsReady } = useRolePermissionMatrix();
  const normalizedRole = sessionRoleNormalized();
  const allowed = useMemo(
    () =>
      getReportSectionVisibility(normalizedRole, rolePermissions).showPerformanceReports,
    [normalizedRole, rolePermissions]
  );

  const fallbackReports = location.pathname.startsWith('/employee')
    ? '/employee/reports'
    : '/admin/reports';

  if (!permissionsReady) return <Loader />;
  if (!allowed) return <Navigate to={fallbackReports} replace />;
  return children;
}
